import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';

import * as Styled from './AppHeader.style';
import { useDrawerState } from '../../hooks/useDrawerState';
import { Logo } from '../Logo';
import { UserMenu } from '../UserMenu';

const AppHeader = () => {
  const { drawerState, toggleDrawer } = useDrawerState();

  const handleButtonPressed = useButtonPressedCallback({
    elementAsset: drawerState ? '/s2/icon/e-remove-outline.svg' : '/s2/icon/zb-menu-outline.svg',
    elementName: 'app_header_toggle'
  });

  const handleToggleDrawer = () => {
    toggleDrawer();
    handleButtonPressed();
  };

  return (
    <Styled.Root>
      <Styled.DrawerButton
        label={drawerState ? 'Close drawer' : 'Open drawer'}
        icon={drawerState ? <CloseIcon /> : <MenuIcon />}
        onClick={handleToggleDrawer}
        open={drawerState}
        tabIndex={0}
      />

      <Styled.LogoContainer data-testid="logo-container">
        <Logo />
      </Styled.LogoContainer>

      <Styled.UserMenuContainer>
        <UserMenu />
      </Styled.UserMenuContainer>
    </Styled.Root>
  );
};

export default AppHeader;
